import clsx from "clsx";

import { CODEX_URL, navigateReviewLink, REVIEW_RUNS_URL } from "@/lib/review-navigation";
import { useStore } from "@/lib/store";

export function ReviewSectionTabs({ active }: { active: "runs" | "codex" }): React.JSX.Element {
  const setView = useStore((state) => state.setView);

  return (
    <nav
      className="border-cyber-border flex items-center overflow-hidden rounded border"
      aria-label="PR review sections"
    >
      <a
        href={REVIEW_RUNS_URL}
        onClick={(event) => navigateReviewLink(event, REVIEW_RUNS_URL, "github-reviews", setView)}
        className={clsx(
          "px-2 py-1 text-xs transition-colors",
          active === "runs"
            ? "bg-cyber-cyan/10 text-cyber-cyan"
            : "text-cyber-muted hover:bg-cyber-surface/50 hover:text-cyber-text",
        )}
      >
        Runs
      </a>
      <a
        href={CODEX_URL}
        onClick={(event) => navigateReviewLink(event, CODEX_URL, "github-reviews-codex", setView)}
        className={clsx(
          "border-cyber-border border-l px-2 py-1 text-xs transition-colors",
          active === "codex"
            ? "bg-cyber-cyan/10 text-cyber-cyan"
            : "text-cyber-muted hover:bg-cyber-surface/50 hover:text-cyber-text",
        )}
      >
        Codex
      </a>
    </nav>
  );
}
